// src/components-top/Left.jsx

import React from "react";
import TableOfContents from "../components/TableOfContents";
import LeafletMap from "../components/LeafletMap";

const Left = (props) => {
  // We pass `labelsMap` to TableOfContents
  // and keep the markers for LeafletMap below.
  return (
    <div className="left-container">
      {/* Table of Contents in top half */}
      <div className="toc-half">
        <TableOfContents labelsMap={props.labelsMap} />
      </div>

      {/* Desktop Map in bottom half */}
      <div className="map-half">
        <LeafletMap
          lat={49.2827}
          lng={-123.1207}
          zoom={12}
          markers={props.locations.map((loc) => ({
            lat: loc.lat,
            lng: loc.lng,
            popupText: loc.popupText,
            markerId: loc.id,
          }))}
          mapRef={props.mapRef}
          spotRefs={props.spotRefs}
        />
      </div>
    </div>
  );
};

export default Left;